export default __webpack_public_path__ + "static/media/KF2.a4f64b21.jpg";